import { useEffect } from 'react';
import { flushDebounceForTable } from './debounceHandler';

export const useFlushDebounceOnMouseMove = (identifier, enabled) => {
  useEffect(() => {
    if (!enabled) return undefined;

    const handleMouseMove = () => {
      flushDebounceForTable(identifier);
    };

    document.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [identifier, enabled]);
};
